import {html} from 'lit';

export class TTAppState {

    static initial() {
        return new TTAppState.Loading("/");
    }

    static loading(url) {
        return new TTAppState.Loading(url);
    }

    static page(data) {
        return new TTAppState.Page(data);
    }

    static error() {
        return new TTAppState.Error();
    }

    static serverError() {
        return new TTAppState.ServerError();
    }

    static networkError() {
        return new TTAppState.Offline();
    }

    static notFound() {
        return new TTAppState.ClientError404();
    }

    static loginRequired() {
        return new TTAppState.LoginRequired();
    }
}

TTAppState.Page = class PageState {
    constructor(data) {
        this.type = 'page';
        this.data = data;
    }

    display(data) {
        return new TTAppState.Page(data);
    }

}

TTAppState.Loading = class LoadingState {

    constructor(url) {
        this.type = 'loading';
        this.url = url;
    }

    display(data) {
        return new TTAppState.Page(data);
    }

}

TTAppState.Offline = class OfflineState {
    constructor() {
        this.type = 'error';

        this.data = {
            title: "Verbindungsprobleme 📡",
            text: "Leider konnten wir keine Verbindung aufbauen.",
            showRetry: true
        }
    }
}

TTAppState.Error = class ErrorState {
    constructor() {
        this.type = 'error';

        this.data = {
            title: "Fehler 😵‍💫",
            text: "Leider ist etwas schiefgelaufen. Bitte versuche es noch einmal.",
            showRetry: true
        }
    }
}

TTAppState.ServerError = class ServerErrorState {
    constructor() {
        this.type = 'error';

        this.data = {
            title: "Server-Fehler 😵‍💫",
            text: "Leider ist etwas schiefgelaufen. Bitte versuche es noch einmal.",
            showRetry: true
        }
    }
}

TTAppState.ClientError404 = class ClientError404State {
    constructor() {
        this.type = 'error';

        this.data = {
            title: "Seite nicht gefunden 🕵",
            text: html`Wir konnten die Seite nicht finden. Willst du stattdessen <a href="/">zurück zur Startseite?</a>`,
            showRetry: false
        }
    }
}

TTAppState.LoginRequired = class LoginRequiredState {
    constructor() {
        this.type = 'login-required';
        this.data = {
            menu: "Community"
        }
    }
}